import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { LotChangeGetCollectionByLotId, LotChangeGetCollectionByLotIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<LotChangeGetCollectionByLotIdResponse, LotChangeGetCollectionByLotIdResponse>) => {
    return response?.data?.lotChanges;
}
const getError = (response?: SWRResponse<LotChangeGetCollectionByLotIdResponse, LotChangeGetCollectionByLotIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useLotChangesByStageLot = (lotId?: number, configuration?: SWRConfiguration<LotChangeGetCollectionByLotIdResponse, LotChangeGetCollectionByLotIdResponse>) => {
    
    const request = useMemo(() => {
        return lotId != undefined ? () => {
                return new LotChangeGetCollectionByLotId({
                    lotId: lotId
                }) 
            }
            : undefined;
    }, [lotId])

    return useGet(request, { getData, getError }, configuration);
}

export default useLotChangesByStageLot;